import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
export default function PaymentCancel() {
  return (
    <div className="text-white max-w-xl mx-auto px-6 py-24 text-center">
      <XCircle size={48} className="text-white/60 mx-auto" />
      <h1 className="mt-6 font-display text-4xl">Payment cancelled.</h1>
      <p className="mt-3 text-white/70">Your cart is saved. You can complete the order whenever you're ready.</p>
      <Link to="/preshhgo" className="mt-8 inline-flex preshh-btn-primary">Return to product</Link>
    </div>
  );
}
